"use strict";
var ApiMessageModalResponse = (function () {
    function ApiMessageModalResponse() {
    }
    return ApiMessageModalResponse;
}());
exports.ApiMessageModalResponse = ApiMessageModalResponse;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/api-message-modal-response.model.js